'use client';

import { useEffect } from 'react';

import { useAttGöra } from 'src/sections/att-gora/use-att-gora';

import type { IOrganisation } from 'src/types/nya/common';
import type { AttGöraPost } from 'src/sections/att-gora/AttGoraTyper';

// ----------------------------------------------------------------------

export type SondRapport = {
  /** `undefined` för hubbens egen rad, dvs. personens egna förfallodagar. */
  organisation?: IOrganisation;
  poster: AttGöraPost[];
};

type Props = {
  /** Utelämnad för personens egna datum (Inkomstdeklaration 1, fastighetsavgift). */
  organisation?: IOrganisation;
  onRapport: (nyckel: string, rapport: SondRapport) => void;
};

/**
 * Läser en organisations förfallodagar åt hubben och rapporterar dem uppåt.
 *
 * <p>Myndighetsdatumen räknas ut lokalt av regelmotorn i `myndighetsdatum.ts` — det
 * finns inget deadline-API att fråga, så de kan inte komma med i det aggregerade
 * svaret från backend. `useAttGöra` är en hook och går därför inte att loopa över
 * användarens föreningar. Lösningen är en sond per förening: varje instans anropar
 * hooken med sin egen organisation och rapporterar resultatet till hubben, som slår
 * ihop dem till en lista.
 *
 * Komponenten renderar ingenting. Den finns bara för att få anropa en hook en gång
 * per organisation.
 */
export default function AttGöraSond({ organisation, onRapport }: Props) {
  const { öppna } = useAttGöra(organisation);
  const nyckel = organisation?.id ?? 'privat';

  useEffect(() => {
    onRapport(nyckel, { organisation, poster: öppna });
  }, [nyckel, organisation, öppna, onRapport]);

  return null;
}
